module.exports = __webpack_public_path__ + "img/contact.1d23a542.svg";